import React, { Component } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { Container } from "semantic-ui-react";

import "semantic-ui-css/semantic.min.css";
import Header from "./HeaderMenu";
import Landing from "./Landing";
import Campaign from "./campaign";
import RecipientList from "./recipients";
import LoginPage from "./auth/login";
import Register from "./auth/registeration";
import Profile from "./account";
import Settings from "./setting";

class App extends Component {
  render() {
    const DefaultContainer = () => (
      <div>
        <Header />
        <Route exact path="/campaigns" component={Campaign} />
        <Container>
          <Switch>
            <Route exact path="/" component={Landing} />
            <Route exact path="/recipients" component={RecipientList} />
            <Route exact path="/account" component={Profile} />
            <Route exact path="/settings" component={Settings} />
          </Switch>
        </Container>
      </div>
    );

    const LoginContainer = () => (
      <Container>
        <Route path="/login" component={LoginPage} />
      </Container>
    );

    return (
      <BrowserRouter>
        <Switch>
          <Route exact path="/register" component={Register} />
          <Route exact path="/login" component={LoginContainer} />
          <Route component={DefaultContainer} />
        </Switch>
      </BrowserRouter>
    );
  }
}

export default App;
